// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__KzLyd","footer":"ModalCreateQualiphyProcedure_footer__1gvrW","additionData":"ModalCreateQualiphyProcedure_additionData__37KH7"};